<template>
  <svg
    width="36"
    height="30"
    viewBox="0 0 36 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="left-quote-title"
  >
    <path
      d="M36 3.64569C36 1.84802 34.4486 0.4046 32.7047 0.841042C25.8168 2.56488 21.6346 7.87623 21.6346 17.1434V20.1369C21.6346 25.9369 24.9231 29.3047 29.0769 29.3047C33.0577 29.3047 36 26.3111 36 22.3821C36 18.089 33.3104 15.3351 29.2927 15.1015C28.9832 15.0835 28.7308 14.834 28.7308 14.524C28.7308 10.8061 30.2733 8.2425 33.6532 6.83339C34.9797 6.28034 36 5.08289 36 3.64569ZM14.3654 3.64569C14.3654 1.84802 12.814 0.4046 11.0701 0.841042C4.18216 2.56488 0 7.87623 0 17.1434V20.1369C0 25.9369 3.28846 29.3047 7.61539 29.3047C11.5962 29.3047 14.3654 26.3111 14.3654 22.3821C14.3654 18.0894 11.8345 15.3356 7.83126 15.1015C7.5218 15.0834 7.26923 14.834 7.26923 14.524C7.26923 10.8105 8.68976 8.24859 12.0203 6.83841C13.3438 6.27805 14.3654 5.08289 14.3654 3.64569Z"
      fill="#FF0099"
    />
    <title id="left-quote-title">quote</title>
  </svg>
</template>

<script lang="ts">
export default {
  name: 'LeftQuote',
};
</script>
